export const AccountUnsimplifier = {
  MAPPING: {
    i: 'id',
    un: 'username',
    ac: 'acct',
    dn: 'display_name',
    l: 'locked',
    ca: 'created_at',
    nt: 'note',
    u: 'url',
    av: 'avatar',
    avs: 'avatar_static',
    avsml: 'avatar_small',
    avss: 'avatar_static_small',
    h: 'header',
    hs: 'header_static',
    is: 'is_spam',
    foc: 'followers_count',
    fic: 'following_count',
    sc: 'statuses_count',
    ip: 'is_pro',
    iv: 'is_verified',
    idn: 'is_donor',
    ii: 'is_investor',
    spl: 'show_pro_life',
    ipd: 'is_parody'
  },

  unsimplifyKey(simplifiedKey) {
    return this.MAPPING[simplifiedKey] || simplifiedKey;
  },

  unsimplify(data) {
    if (Array.isArray(data)) {
      return data.map(this.unsimplifyObject.bind(this));
    } else {
      return this.unsimplifyObject(data);
    }
  },

  unsimplifyObject(obj) {
    const newObj = {};
    for (const key in obj) {
      const unsimplifiedKey = this.unsimplifyKey(key);
      newObj[unsimplifiedKey] = obj[key];
    }
    return newObj;
  }
};